module.exports = __webpack_public_path__ + "media/images/bg/mosaic/lector-1616b7280d68daf2e7610f90f4f28fc5.jpg";